// extracted by mini-css-extract-plugin
module.exports = {"list":"RatingCategoriesList_list_36t2q","icon":"RatingCategoriesList_icon_aFZmS","popper":"RatingCategoriesList_popper_4IbFa"};